<template>
	<div>
		<div
			class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto my-auto bg-color--light--2"
		>
			<h4 class="text-center pt-3">
				{{ $t("contract.instalments_noteBook") }}
			</h4>
			<div class="container">
								<!-- <h4 class="text-dark text-align-center">وضعیت</h4> -->
								<br />

								<div class="d-flex flex-lg-row flex-column flex-wrap justify-content-between">
									
									<div class="col-12 col-lg-3">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ "وضعیت پرداخت" + "  :  " }}</label
											>
											
											<label
												v-if="pay_status == 1"
												class="form__label text-uppercase font-size--15 font-w--400"
												><span class="badge badge-success">{{$t("instalment.good")}}</span></label
											>
											<label
												v-if="pay_status == 2"
												class="form__label text-uppercase font-size--15 font-w--400"
												><span class="badge badge-warning">{{$t("instalment.irregular")}}</span></label
											>
											<label
												v-if="pay_status == 3"
												class="form__label text-uppercase font-size--15 font-w--400"
												><span class="badge badge-danger">{{$t("instalment.danger")}}</span></label
											>
											<label
												v-if="pay_status == 4"
												class="form__label text-uppercase font-size--15 font-w--400"
												><span class="badge badge-danger">{{$t("instalment.bad")}}</span></label
											>
											

										</div>
									</div>

									<div class="col-12 col-lg-3 row">
										<div class="font-size--15 font-w--500">مبلغ قسط:</div>
										<div>{{amount}} </div>
										<div class="currency" >{{$t("instalment.currency")}}</div>
									</div>
									<div class="col-12 mt-1 mt-lg-0 col-lg-3 row">
										<div class="font-size--15 font-w--500">مبلغ باقی مانده:</div>
										<div>{{remain_amount}} </div>
										<div class="currency" >{{$t("instalment.currency")}}</div>
										
									</div>
									<div class="col-12 mt-1 mt-lg-0 col-lg-3 row">
										<div class="font-size--15 font-w--500">مبلغ جریمه:</div>
										<div>{{penalty_amount}}</div>
										<div class="currency" >{{$t("instalment.currency")}}</div>
									</div>
									<div class="col-12 mt-1 mt-lg-0 col-lg-3 row pl-lg-3">
										<div class="font-size--15 font-w--500">مجموع تعداد روز دیرکرد:</div>
										<div>{{total_diff}}</div>
										
									</div>
								</div>

							</div>
			<vue-good-table
				:columns="columns"
				:rows="rows"
				:line-numbers="true"
				:rtl="true"
				:row-style-class="rowStyleClassFn"
				class="mt-3  pb-10 mr-0 ml-0 px-2 pt-1"
			>
				<template slot="table-row" slot-scope="props">
					<span v-if="props.column.field == 'status'">
						<span v-html="statusFn(props.row.status)"> </span>
					</span>
					<span v-else-if="props.column.field == 'date'">
						{{ props.row.date | moment("jYYYY/jMM/jD ") }}</span
					>
					<span v-else-if="props.column.field == 'clearing_date'">
						{{ props.row.clearing_date | moment("jYYYY/jMM/jD ") }}</span
					>

					<span v-else>
						{{ props.formattedRow[props.column.field] }}
					</span>
				</template>
			</vue-good-table>
		</div>
	</div>
</template>


<script>
// import HeaderSuplier from "../components/shared/HeaderSuplier";
// import VueNumeric from "vue-numeric";
export default {
	props: ["id", "contract_id"],
	data() {
		
		return {
			
			amount:null,
			remain_amount:null,
			penalty_amount:null,
			total_diff:null,
			columns: [
				{
					label: "تاریخ سررسید",
					field: "date",
					tdClass: "text-center",
					thClass: "text-center",
				},
				{
					label: "تاریخ تسویه",
					field: "clearing_date",
					tdClass: "text-center",
					thClass: "text-center",
				},
				{
					label: "تعداد روز دیرکرد",
					field: "difference",
					tdClass: "text-center",
					thClass: "text-center",
				},
				{
					label: "وضعیت",
					field: "status",
					tdClass: "text-center",
					thClass: "text-center",
				},
			],
			rows: [],
			pay_status:""
		};
	},
	mounted() {
		// this.$tabs.refresh('/supplier/customers/351');
		
		this.getCustomerInstalments();
		// this.getSuppliersCustomer();
	},
	computed: {},
	methods: {
		statusFn: function(st) {
			// if (st === "0") {
			// 	return '<span class="badge badge-warning" style="height:25px;text-align:center"><b>پرداخت با تاخیر</b></span>';
			// }
			if (st === "1") {
				return '<span class="badge badge-success" style="height:25px;"><b>پرداخت شده</b></span>';
			}
			if (st === "2") {
				return '<span class="badge badge-danger" style="height:25px;"><b> پرداخت نشده</b></span>';
			}
			if (st === "3") {
				return '<span class="badge badge-secondary" style="height:25px;text-align:center"><b>موعد قسط نرسیده است</b></span>';
			}

			return;
		},
		actionBtn: function() {
			return '<button  @click.prevent="showContractDetail" type="button" class="btn btn-primary text-center font-w--400 " style="width:70px;height:35px;font-size: 0.75rem;">جزییات</button>';
		},
		rowStyleClassFn(row) {
			if (row.status === "0") {
				return "bg-warning";
			}
			if (row.status === "1") {
				return "bg-success";
			}
			if (row.status === "2") {
				return "bg-danger";
			}
			if (row.status === "3") {
				return "bg-light";
			}
		},
		// eslint-disable-next-line no-unused-vars
	
		// payStatusShow(st) {
		// 	if (st === "1") {
		// 		return '<span class="badge badge-succes" style="height:25px;"><b>خوش‌ حساب</b></span>';
		// 	}
		// 	if (st === "2") {
		// 		return '<span class="badge badge-warning" style="height:25px;"><b> پرداخت نا‌منظم</b></span>';
		// 	}
		// 	if (st === "3") {
		// 		return '<span class="badge badge-danger" style="height:25px;text-align:center"><b>پرداخت پرخطر</b></span>';
		// 	}
		// },
		
		getCustomerInstalments() {
			// console.log("props= ", this.id);
console.log("id: ", this.id)
				console.log("contract_id: ", this.contract_id)
			this.$store
				.dispatch("getSuppliersCustomerInstalments", this.contract_id)
				.then((resp) => {
					this.rows = resp.body.instalment_detail.instalments;
					this.pay_status=resp.body.instalment_detail.pay_status
					this.amount = resp.body.instalment_detail.amount
					this.remain_amount = resp.body.instalment_detail.remain_amount
					this.penalty_amount = resp.body.instalment_detail.penalty_amount
					this.total_diff = resp.body.instalment_detail.total_diff
					console.log(resp)
				})
				.catch((err) => {
					console.log(err);
				});
		},
	},
	components: {
		// VueNumeric,
	},
};
</script>

<style>
.currency
{
	margin-right:3px
}
</style>